require("./index.less");

console.log("It's ready...");



/** WEBPACK FOOTER **
 ** C:/Users/yxfanxiao/git/foo/template/src/index.js
 **/